<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  font-size: 14px;
}
.m-l-70 {
  margin-left: 70px;
}
.m-l-10{
  margin-left: 10px;
}
.m-t-20 {
  margin-top: 20px;
}
.m-r-20 {
  margin-right: 20px;
}
.m-t-10 {
  margin-top: 10px;
}
.m-r-10 {
  margin-right: 10px;
}
.m-l-5 {
  margin-left: 5px;
}
.m-l-50 {
  margin-left: 50px;
}
.m-t-50 {
  margin-top: 50px;
}
.el-drawer__body {
  overflow: auto;
}
:focus {
  outline: none;
}
.p-l-30 {
  padding-left: 30px;
}
.p-r-30 {
  padding-right: 30px;
}
.el-input__inner{
  line-height: 1px!important;
}
.p-t-10{
  padding-top: 10px;
}
.p-20{
  padding: 20px;
}
.el-message{
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue